module.exports = __webpack_public_path__ + "static/media/RRD2-BG2.525c42a9.jpg";